import BaseApiService from "./base-services/baseApi.service";

class CommonApiService extends BaseApiService {
  constructor() {
    super();
  }

  saveDeviceToken = async (payload) => {
    const url = `/website/device/token`;
    const res = await this.axiosInstance.post(url, payload);
    return res.data;
  };
}

const commonApiService = new CommonApiService();
export { commonApiService };
